module.exports = __webpack_public_path__ + "img/M-Suite Logo.1414c8d7.svg";